/**
 * Purpose: Bootstrap the React application into the root DOM node.
 * Assumptions: index.html provides a #root mount point and App is the top-level UI.
 * External refs: react-dom createRoot API and React StrictMode behavior.
 */
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
